export function extend(Runtime, library) {
    class Chart extends Runtime {
        constructor(options) {
            super(Object.assign(Object.assign({}, options), { lib: library }));
        }
    }
    return Chart;
}
//# sourceMappingURL=extend.js.map